<template>
  <div class="bg-white px-5 min-h-screen pt-20 shadow-xl">
    <div v-if="loaded" class="grid grid-cols-3 space-x-6">
      <div id="legalDocument" class="col-span-3 py-10">
        <LegalDocumentTitle
          v-if="legalDocumentTemplateStore.sections && legalDocumentTemplateStore.sections.title"
          :content="legalDocumentTemplateStore.sections?.title?.content"
          :template-variables="legalDocumentTemplateStore.sections?.title?.template_variables"
        ></LegalDocumentTitle>
        <div id="contract-pdf-output-container" class="flex flex-col space-y-14">
          <LegalDocumentSection
            v-for="item in legalDocumentStore.sections"
            :key="item"
            :clause="legalDocumentTemplateStore.sections[item]?.numbered_paragraph ? numberSections.indexOf(item) + 1 : 0"
            :code="item"
          ></LegalDocumentSection>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, onMounted, ref, watch } from 'vue'
import LegalDocumentTitle from '../components/LegalDocument/LegalDocumentTitle.vue'
import LegalDocumentSection from '../components/LegalDocument/LegalDocumentSection.vue'
import { useLegalDocumentTemplateStore } from '../stores/legalDocumentTemplate'
import { useLegalDocumentStore } from '../stores/legalDocument'
import { useQuestionnaireStore } from '../stores/questionnaire'

const props = defineProps<{ documentId: string }>()
const legalDocumentTemplateStore = useLegalDocumentTemplateStore()
const legalDocumentStore = useLegalDocumentStore()
const questionnaireStore = useQuestionnaireStore()
const sectionNumber: { [key: string]: boolean } = {}

const getNumberedSections = () => {
  if (!legalDocumentTemplateStore.sections) return []
  return Object.values(legalDocumentTemplateStore.sections)
    .filter(section => section?.numbered_paragraph && legalDocumentStore.sections.includes(section?.code))
    .map(sec => sec.code)
}

const numberSections = ref<string[]>(getNumberedSections())
const loaded = computed(() => {
  return legalDocumentTemplateStore.loaded && questionnaireStore.loaded
})

watch(
  () => legalDocumentStore.sections.length,
  () => {
    numberSections.value = getNumberedSections()

    Object.values(legalDocumentStore.sections).forEach(section => {
      if (legalDocumentTemplateStore.sections[section]?.numbered_paragraph) {
        sectionNumber[section] = true
      }
    })
  }
)

onMounted(async () => {
  const { documentId } = props
  await questionnaireStore.fetchData(documentId).then(async () => {
    await legalDocumentTemplateStore.fetchData(documentId)
    if (legalDocumentTemplateStore.sections) {
      const sections: string[] = Object.values(legalDocumentTemplateStore.sections)
        .filter(
          section =>
            !section.optional || questionnaireStore.templateVariableValues[`section___${section.code}`] || section.optional_but_selected
        )
        .map(section => section.code)
      const initialSortOrder: string[] = Object.values(legalDocumentTemplateStore.sections).map(section => section.code)

      legalDocumentStore.initialSortSort(initialSortOrder)
      legalDocumentStore.$patch({ sections })
    }
  })
})
</script>
